<template>
  <div class="feedback" >
      <div @click="showModal">
        <slot >
          <div class="feedback-icon">
            <eco-icon
              name="feedback"
              color="#222"
              :size="24"
            ></eco-icon>
            </div>
        </slot>
      </div>


    <a-modal
      title="反馈"
      :visible="visible"
      :confirm-loading="confirmLoading"
      :width="720"
      okText="发送"
      cancelText="取消"
      @ok="handleOk"
      @cancel="handleCancel"
    >
    

  <p>
    针对于VIP专区中文档/文章，请您提供宝贵建议。如需技术咨询，请拨打400 991 6599热线咨询。
  </p>
  <a-form-model ref="ruleForm" :model="form" :rules="rules">
    
    <a-form-model-item label="问题类型" prop="ftype">
      <a-radio-group v-model="form.ftype" >
        <a-radio :value="v.value" :name="v.value" v-for="v in ftype" :key="v.value">
          {{v.text}}
        </a-radio>
      </a-radio-group>
    </a-form-model-item>

    <a-form-model-item label="意见描述"  prop="content">
      <a-input v-model="form.content" type="textarea" placeholder="请标注文档中具体章节及位置，并详细的说明相关问题，以便我们更好的改进。"/>
    </a-form-model-item>

    <a-form-model-item label="联系方式"  prop="contact">
      <a-input v-model="form.contact" placeholder="如果您需要我们与您联系，可以留下您的联系方式，手机号或者邮箱"/>
    </a-form-model-item>
  </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import {getTypeList, sendFeedback} from './request/feedback.js'


export default {
  props:['vipId'],
  data() {
    return {
      ModalText: 'Content of the modal',
      visible: false,
      confirmLoading: false,
      ftype:[],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        ftype: undefined,
        content: '',
        contact: '',
      },
      
      rules: {
        ftype: [
            { required: true, message: '请选择问题类型', trigger: 'blur' },
        ],
        content: [
            { required: true, message: '请输入意见描述内容', trigger: 'blur' },
            { max: 2000, message: '意见描述内容应小于 2000 个字', trigger: 'blur' },
        ],
        contact: [ 
            { max: 500, message: '联系方式应小于 2000 个字', trigger: 'blur' }
        ],
      },
    };
  },
  async mounted(){
    const list = await getTypeList()
    this.ftype = list
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    async handleOk(e) {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
            sendFeedback({
                ... this.form,
                vipId:this.vipId
            }).then(()=>{
                this.$message.success('发送成功！')
                this.handleCancel()
            })
        } else {
          return false;
        }
      });
    },
    handleCancel(e) {
      this.visible = false;
      this.form =  { ftype: undefined,  content: '', contact: ''}
      this.$refs.ruleForm.resetFields();
    },
    onSubmit() {
      console.log('submit!', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
// .feedback{
//     position: absolute;
// }

// .feedback-icon{
//     position: fixed;

//     bottom: 218px;
//     right: 24px;

//     z-index: 999;
//     cursor: pointer;
//     width: 50px;
//     height: 50px;
//     line-height: 58px;
//     text-align: center;
//     border-radius: 50%;
//     background: hsla(0, 0%, 71.4%, .2);

//     &:hover{
//         *{
//             color: #4771F8 !important;
//         }
//     }
// }

.feedback{
  display: inline-block;
}

</style>